import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import Moment from 'moment';
import User from '_class/User';
import swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getSchedule } from 'actions/schedule';
import { setPageTitle, setPageActions } from 'actions/header';
import { getUserInfo } from 'actions/user';
import { debounce } from 'helpers/content';
import { getWithExpiration, saveWithExpiration } from 'helpers/localstorage';
import Modal from 'containers/Modals/Modal';
import CalendarEventForm from 'containers/Forms/CalendarEvent';
import SelectUserForm from './Partials/SelectUserForm';
import ScheduleView from './ScheduleView';
import { Spinner } from 'UI';
import { Icon, Tabs, Tab, onLanguageChange } from '@haldor/ui';
import CalendarHeader from './CalendarHeader';
import AssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';

var Schedule = /*#__PURE__*/function (_Component) {
  _inherits(Schedule, _Component);

  var _super = _createSuper(Schedule);

  function Schedule(props) {
    var _this;

    _classCallCheck(this, Schedule);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isAllowed", function () {
      var user = new User(_this.props.user);
      return user.isTeacher() || user.isUserCurriculumAdmin() || user.isSchoolLeader() || user.isSMSAdmin() || user.isPedagogue() || user.isOperationManager() || user.isMentor() || user.isCourseAdministrator() || user.isAdministrator();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener('resize', _this.resize);
      window.addEventListener('hashchange', _this.tabChangeEvent);
      onLanguageChange(function () {
        saveWithExpiration('haldor-schedule-date', Moment().format());
      });

      _this.resize();

      var user = _this.props.user;
      var tabsData = localStorage.getItem('haldor-schedule-tabs');
      var activeTab = localStorage.getItem('haldor-schedule-active-tab');

      if (tabsData != null) {
        if (JSON.parse(tabsData).tabs == null || JSON.parse(tabsData).userId != user.id) {
          localStorage.removeItem('haldor-schedule-tabs');
          localStorage.removeItem('haldor-schedule-active-tab');

          _this.setState({
            loading: false
          });

          return false;
        }

        _this.setState({
          tabs: JSON.parse(tabsData).tabs
        }, function () {
          var promises = [];

          _this.state.tabs.forEach(function (tab) {
            if (tab.type == 'teacher') {
              var userPromise = _this.props.getUserInfo(tab.id);

              promises.push(userPromise);
            }
          });

          Promise.allSettled(promises).then(function () {
            if (activeTab != null) {
              var foundTab = _this.state.tabs.find(function (tab) {
                return tab.id == activeTab;
              });

              if (foundTab != null) {
                window.location.hash = activeTab;
              } else {
                localStorage.removeItem('haldor-schedule-active-tab');
              }
            }

            _this.setState({
              loading: false
            });
          });
        });
      } else {
        _this.setState({
          loading: false
        });
      }

      if (_this.props.overview) {
        return false;
      }

      _this.props.setPageTitle(_this.props.translate('schedule-header-overview'));

      _this.tabChangeEvent();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.resize);
      window.removeEventListener('hashchange', _this.tabChangeEvent);
    });

    _defineProperty(_assertThisInitialized(_this), "setActions", function () {
      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.overview) {
        return true;
      }

      var actions = [];
      var user = new User(_this.props.user);

      if (!user.isTeacher() && !user.isMentor()) {
        return false;
      } //Submenu buttons for header


      var subMenu = [];

      if (_this.props.services.advancedSchedule) {
        subMenu = [{
          value: _this.props.translate('create-lesson'),
          onClick: _this.toggleForm
        }, {
          value: _this.props.translate('Create assignment'),
          onClick: _this.toggleAssignment
        }, {
          value: _this.props.translate('Create group assignment'),
          onClick: _this.toggleGroupAssignment
        }];
      }

      if (disabled) {
        actions.push({
          type: 'dropDown',
          value: _this.props.translate('Create'),
          icon: 'plus',
          onClick: _this.toggleForm,
          disabled: true,
          subButtons: subMenu
        });
      } else {
        if (!_this.props.services.advancedSchedule) {
          actions.push({
            type: 'button',
            value: _this.props.translate('Create'),
            icon: 'plus',
            onClick: _this.toggleForm
          });
        } else {
          actions.push({
            type: 'dropDown',
            value: _this.props.translate('Create'),
            icon: 'plus',
            onClick: _this.toggleForm,
            subButtons: subMenu
          });
        }
      }

      _this.props.setPageActions(actions);
    });

    _defineProperty(_assertThisInitialized(_this), "scheduleButtons", function (action, date) {
      if (action === 'create-lesson') {
        _this.toggleForm(false, date);

        return;
      } else if (action === 'Create assignment') {
        _this.toggleAssignment(false, date);

        return;
      }

      _this.toggleGroupAssignment(false, date);
    });

    _defineProperty(_assertThisInitialized(_this), "resize", debounce(function () {
      var width = document.body.offsetWidth;

      if (width <= _this.breakpoint) {
        if (!_this.state.mobile) {
          _this.setState({
            mobile: true
          });
        }
      } else {
        if (_this.state.mobile) {
          _this.setState({
            mobile: false
          });
        }
      }

      _this.setState({
        windowWidth: width
      });
    }, 125, false));

    _defineProperty(_assertThisInitialized(_this), "handleGroupDisplay", function (groupName) {
      _this.setState({
        groupSelected: groupName
      });
    });

    _defineProperty(_assertThisInitialized(_this), "tabChangeEvent", function () {
      var hash = window.location.hash.replace('#', '');
      localStorage.setItem('haldor-schedule-active-tab', hash);

      if (hash == '' || hash == 'me') {
        _this.setActions(false);
      } else {
        _this.setActions(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goBack", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var type;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = _this.state.type;

              if (_this.state.mobile) {
                type = 'day';
              }

              if (!(type == 'month')) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return _this.setState({
                date: Moment(_this.state.date).subtract(1, 'month')
              });

            case 5:
              _context.next = 14;
              break;

            case 7:
              if (!(type == 'week' || type == 'work_week')) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return _this.setState({
                date: Moment(_this.state.date).subtract(1, 'week')
              });

            case 10:
              _context.next = 14;
              break;

            case 12:
              _context.next = 14;
              return _this.setState({
                date: Moment(_this.state.date).subtract(1, 'day')
              });

            case 14:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "setModalTitle", function (title) {
      _this.setState({
        modalTitle: title
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goForward", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var type;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              type = _this.state.type;

              if (_this.state.mobile) {
                type = 'day';
              }

              if (!(type == 'month')) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return _this.setState({
                date: Moment(_this.state.date).add(1, 'month')
              });

            case 5:
              _context2.next = 14;
              break;

            case 7:
              if (!(type == 'week' || type == 'work_week')) {
                _context2.next = 12;
                break;
              }

              _context2.next = 10;
              return _this.setState({
                date: Moment(_this.state.date).add(1, 'week')
              });

            case 10:
              _context2.next = 14;
              break;

            case 12:
              _context2.next = 14;
              return _this.setState({
                date: Moment(_this.state.date).add(1, 'day')
              });

            case 14:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "goToday", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                date: Moment()
              });

            case 2:
              saveWithExpiration('haldor-schedule-date', _this.state.date.format());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "setType", function (event) {
      if (_this.state.type != event.target.value) {
        localStorage.setItem('haldor-schedule-type', event.target.value);

        _this.setState({
          type: event.target.value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleButtons", function () {
      if (_this.state.mobile) {
        return null;
      }

      var translate = _this.props.translate;
      var type = _this.state.type;
      return /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: type,
        onChange: _this.setType
      }, /*#__PURE__*/React.createElement("option", {
        value: "day"
      }, translate('day')), /*#__PURE__*/React.createElement("option", {
        value: "work_week"
      }, translate('Work week')), /*#__PURE__*/React.createElement("option", {
        value: "week"
      }, translate('week')), _this.props.services.advancedSchedule ? /*#__PURE__*/React.createElement("option", {
        value: "month"
      }, translate('month')) : null, /*#__PURE__*/React.createElement("option", {
        value: "agenda"
      }, translate('agenda'))));
    });

    _defineProperty(_assertThisInitialized(_this), "notReportedSchedulePositions", function () {
      if (_this.props.schedulePositions != null && _this.props.schedulePositions.length > 0) {
        return /*#__PURE__*/React.createElement(Link, {
          to: "/report/attendance",
          className: "see-more"
        }, _this.props.schedulePositions.length + ' ' + _this.props.translate('not-reported'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleForm", function (removeDate, date) {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'create-lesson',
        dateEvents: removeDate ? null : date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAssignment", function (removeDate, date) {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'Create assignment',
        dateEvents: removeDate ? null : date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroupAssignment", function (removeDate, date) {
      _this.setState({
        createEvent: !_this.state.createEvent,
        formName: 'Create group assignment',
        dateEvents: removeDate ? null : date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeNewModal", function () {
      window.location.hash = 'me';
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (skip == true) {
        _this.setState({
          createEvent: !_this.state.createEvent,
          modalTitle: ''
        });
      } else {
        swal.fire({
          title: _this.props.translate('are-you-sure'),
          text: _this.props.translate('close-form-prompt'),
          showCancelButton: true,
          cancelButtonText: _this.props.translate('No'),
          confirmButtonText: _this.props.translate('Yes')
        }).then(function (result) {
          if (result.value != null) {
            _this.setState({
              createEvent: !_this.state.createEvent,
              modalTitle: '',
              groupSelected: '',
              dateEvents: null
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (date) {
      var currentHash = window.location.hash.replace('#', '');

      if (currentHash != '' && currentHash != 'me') {
        window.location.hash = 'me';
      }

      _this.setState({
        date: Moment(date)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTeacherSubmit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
          var user;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  user = _this.props.user;

                  if (!(values == null)) {
                    _context4.next = 3;
                    break;
                  }

                  return _context4.abrupt("return", false);

                case 3:
                  _context4.next = 5;
                  return _this.setState({
                    tabs: [].concat(_toConsumableArray(_this.state.tabs), [{
                      id: values.userId,
                      type: 'teacher'
                    }])
                  });

                case 5:
                  localStorage.setItem('haldor-schedule-tabs', JSON.stringify({
                    userId: user.id,
                    tabs: _this.state.tabs
                  }));
                  _context4.next = 8;
                  return _this.props.getUserInfo(values.userId);

                case 8:
                  window.location.hash = values.userId;
                  resolve(1);

                case 10:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "removeTab", function (tab, clickEvent) {
      var foundIndex = _this.state.tabs.findIndex(function (t) {
        return t.id == tab.id;
      });

      var currentHash = window.location.hash.replace('#', '');
      var user = _this.props.user;

      _this.setState({
        tabs: _this.state.tabs.filter(function (t) {
          return t.id != tab.id;
        })
      }, function () {
        localStorage.setItem('haldor-schedule-tabs', JSON.stringify({
          userId: user.id,
          tabs: _this.state.tabs
        }));

        if (tab.id == currentHash) {
          if (_this.state.tabs.length > 0 && foundIndex > 0) {
            window.location.hash = _this.state.tabs[foundIndex - 1].id;
          } else {
            window.location.hash = 'me';
          }
        } else {
          window.location.hash = currentHash;
        }
      });

      if (clickEvent != null) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '12px',
          width: '15px',
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTabTitle", function (tab) {
      if (tab.type == 'teacher') {
        var user = _this.props.users.find(function (u) {
          return u.userId == tab.id;
        });

        if (user == null) {
          return null;
        }

        var teacher = new User(user);
        return /*#__PURE__*/React.createElement("div", {
          className: "df aic remove"
        }, teacher.getName(), /*#__PURE__*/React.createElement(Icon, {
          onClick: function onClick(event) {
            return _this.removeTab(tab, event);
          },
          name: "Close"
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTabs", function () {
      if (_this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var isToday = Moment().isSame(_this.state.date, _this.state.type == 'week' ? 'week' : 'day');
      var user = new User(_this.props.user);
      var translate = _this.props.translate;
      var studentId = null;
      var type = _this.state.type;

      var school = _this.props.user.schools.find(function (school) {
        return school.id == _this.props.activeSchool;
      });

      if (_this.state.mobile) {
        type = 'day';
      }

      if (user.isStudent()) {
        studentId = _this.props.user.id;
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: user.getName(),
        route: "me"
      }, /*#__PURE__*/React.createElement(CalendarHeader, {
        notReportedSchedulePositions: _this.notReportedSchedulePositions,
        toggleForm: _this.toggleForm,
        toggleAssignment: _this.toggleAssignment,
        toggleGroupAssignment: _this.toggleGroupAssignment,
        translate: _this.props.translate,
        goToday: _this.goToday,
        isToday: isToday,
        toggleIcon: _this.toggleIcon,
        goBack: _this.goBack,
        displayAdvanced: true,
        goForward: _this.goForward,
        tranSlate: _this.props.translate,
        isStudentCard: _this.props.studentCard,
        overview: _this.props.overview,
        toggleButtons: _this.toggleButtons,
        actions: _this.setActions
      }), /*#__PURE__*/React.createElement(ScheduleView, _extends({
        view: type,
        scheduleButtons: _this.scheduleButtons,
        date: _this.state.date,
        advancedCalendar: _this.props.advancedCalendar,
        userId: studentId,
        isStudentCard: _this.props.studentCard,
        overview: _this.props.overview,
        windowWidth: _this.state.windowWidth
      }, _this.props))), _this.state.tabs.length > 0 ? _this.state.tabs.map(function (tab) {
        var user = _this.props.users.find(function (u) {
          return u.userId == tab.id;
        });

        if (user == null) {
          return null;
        }

        if (tab.type == 'teacher') {
          return /*#__PURE__*/React.createElement(Tab, {
            title: _this.renderTabTitle(tab),
            route: tab.id,
            key: tab.id
          }, /*#__PURE__*/React.createElement(CalendarHeader, {
            notReportedSchedulePositions: _this.notReportedSchedulePositions,
            toggleForm: _this.toggleForm,
            translate: _this.props.translate,
            goToday: _this.goToday,
            isToday: isToday,
            toggleIcon: _this.toggleIcon,
            goBack: _this.goBack,
            tranSlate: _assertThisInitialized(_this),
            goForward: _this.goForward,
            overview: _this.props.overview,
            isStudentCard: _this.props.studentCard,
            toggleButtons: _this.toggleButtons,
            displayAdvanced: false,
            noFilter: true,
            noCreate: true
          }), /*#__PURE__*/React.createElement(ScheduleView, _extends({
            view: type,
            isStudentCard: _this.props.studentCard,
            date: _this.state.date,
            noAdvanced: true,
            userId: user.userId,
            notOwner: true
          }, _this.props)));
        }

        return null;
      }).filter(function (tab) {
        return tab != null;
      }) : null, _this.isAllowed() ? /*#__PURE__*/React.createElement(Tab, {
        title: /*#__PURE__*/React.createElement("div", {
          className: "df aic"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Plus"
        }), ' ', /*#__PURE__*/React.createElement("span", {
          className: "icon-label"
        }, translate('Add schedule'))),
        route: "new"
      }, /*#__PURE__*/React.createElement("div", null)) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSingleSchedule", function () {
      var user = new User(_this.props.user);
      var type = _this.state.type;
      var userId = _this.props.studentId;

      if (_this.state.mobile) {
        type = 'day';
      }

      var isToday = Moment().isSame(_this.state.date, _this.state.type == 'week' ? 'week' : 'day');

      if (user.isStudent()) {
        userId = _this.props.user.id;
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CalendarHeader, {
        notReportedSchedulePositions: _this.notReportedSchedulePositions,
        toggleForm: _this.toggleForm,
        goToday: _this.goToday,
        isToday: isToday,
        toggleIcon: _this.toggleIcon,
        hasGroup: true,
        overview: _this.props.overview,
        goBack: _this.goBack,
        isStudentCard: _this.props.studentCard,
        goForward: _this.goForward,
        toggleButtons: _this.toggleButtons
      }), /*#__PURE__*/React.createElement(ScheduleView, _extends({
        view: type,
        isStudentCard: _this.props.studentCard,
        date: _this.state.date,
        noAdvanced: true,
        userId: _this.props.studentId
      }, _this.props)));
    });

    _defineProperty(_assertThisInitialized(_this), "handleTitle", function () {
      if (_this.state.groupSelected) {
        return "".concat(_this.props.translate(_this.state.formName), " ").concat(_this.props.translate('for'), " ").concat(_this.state.groupSelected);
      } else if (_this.state.modalTitle.length > 0) {
        return "".concat(_this.props.translate(_this.state.formName), " ").concat(_this.props.translate('for'), " ").concat(_this.state.modalTitle);
      }

      return _this.props.translate(_this.state.formName);
    });

    _this.breakpoint = 730;
    var _type = 'work_week';

    var _date = Moment();

    if (localStorage.getItem('haldor-schedule-type') != null) {
      _type = localStorage.getItem('haldor-schedule-type');
    }

    if (getWithExpiration('haldor-schedule-date') != null) {
      _date = Moment(getWithExpiration('haldor-schedule-date'));
    }

    _this.state = {
      loading: true,
      createEvent: false,
      formName: '',
      type: _type,
      date: _date,
      mobile: document.body.offsetWidth <= _this.breakpoint,
      tabs: [],
      modalTitle: '',
      groupSelected: '',
      dateEvents: null,
      windowWidth: 0
    };
    return _this;
  }

  _createClass(Schedule, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.user);
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, this.props.overview && !this.props.studentCard ? /*#__PURE__*/React.createElement("div", {
        className: "calenderToolBar"
      }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Calendar"
      }), /*#__PURE__*/React.createElement("span", {
        className: "schedule-title"
      }, this.props.translate('schedule-header-overview')))) : null, /*#__PURE__*/React.createElement("div", {
        className: this.state.mobile ? 'schedule section mobile' : 'schedule section',
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeModal
        /* title={this.props.translate('create-lesson')} */
        ,
        title: this.handleTitle()
      }, this.state.formName.includes('lesson') ? /*#__PURE__*/React.createElement(CalendarEventForm, {
        onAbort: this.closeModal,
        sectionId: this.props.sectionId,
        onSubmit: this.onSubmit,
        setModalTitle: this.setModalTitle,
        hasDate: this.state.dateEvents
      }) : this.state.formName.includes('group') ? /*#__PURE__*/React.createElement(AssignmentForm, {
        onAbort: this.closeModal,
        editView: false,
        cloneView: false,
        disablePlanSelector: true,
        displayTitle: this.handleGroupDisplay,
        hasDate: this.state.dateEvents,
        onSubmit: this.onSubmit,
        dontRedirect: true
      }) : /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        onAbort: this.closeModal,
        editView: false,
        cloneView: false,
        onSubmit: this.onSubmit,
        disablePlanSelector: true,
        displayTitle: this.handleGroupDisplay,
        hasDate: this.state.dateEvents
      })), /*#__PURE__*/React.createElement(Modal, {
        type: "small news",
        overridePrompt: true,
        isOpen: window.location.hash == '#new',
        onClose: this.closeNewModal
      }, /*#__PURE__*/React.createElement(SelectUserForm, {
        onSubmit: this.onTeacherSubmit,
        forbiddenUsers: this.state.tabs.map(function (t) {
          return t.id;
        })
      })), this.props.studentId != null || user.isStudent() ? this.renderSingleSchedule() : this.renderTabs()));
    }
  }]);

  return Schedule;
}(Component);

function mapStateToProps(state) {
  return {
    user: state.user.currentUser,
    users: state.user.info,
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    schedulePositions: state.schedule.schedulePositions,
    section: state.sections.activeSection,
    activeSchool: state.user.activeSchool,
    advancedCalendar: state.ScheduleFilter.advancedCalendarActive
  };
}

export default connect(mapStateToProps, {
  getSchedule: getSchedule,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getUserInfo: getUserInfo
})(Schedule);